import { InstallationGuide, PageWrapper } from '@src/components';
import { useGetFaqsQuery } from '@src/services/faq/faqApiSlice';
import { ArrowCircleDown, ArrowCircleRight } from 'iconsax-react';
import { useTranslation } from 'react-i18next';
import { Collapse } from 'antd';
import clsx from 'clsx';

export function Faq() {
  const { t } = useTranslation();
  const { data: faqs, isLoading } = useGetFaqsQuery({});

  return (
    <PageWrapper
      title={t('pages.faq.title')}
      loading={isLoading}
      rootClassName='[&_.ant-collapse]:!bg-white dark:[&_.ant-collapse]:!bg-black [&_.ant-collapse]:border-0 [&_.ant-collapse-item-active]:dark:!border [&_.ant-collapse-item-active]:dark:!border-wl-on-background'
    >
      <Collapse
        accordion
        items={faqs?.map((faq) => ({
          key: faq.id,
          label: (
            <span className='font-inter font-medium text-base'>
              {faq.question}
            </span>
          ),
          children: (
            <p className='font-inter font-normal text-base'>{faq.answer}</p>
          ),
          className: clsx(
            'faq-panel mb-4 bg-wl-background !border-none !rounded-xl',
            '[&_.ant-collapse-content]:!border-t [&_.ant-collapse-content]:!border-wl-primary/20 [&_.ant-collapse-content]:bg-wl-background [&_.ant-collapse-content]:rounded-b-lg',
            '[&_.ant-collapse-content-box]:!p-0 [&_.ant-collapse-content]:!mx-4 [&_.ant-collapse-content-box]:!py-4',
            '[&_.ant-collapse-header-text]:!text-wl-on-background',
            '[&_.ant-collapse-content-box]:!text-wl-on-background'
          ),
        }))}
        expandIconPosition='end'
        expandIcon={({ isActive }) =>
          isActive ? (
            <ArrowCircleDown variant='Bulk' className='!text-wl-primary' />
          ) : (
            <ArrowCircleRight variant='Bulk' className='!text-wl-primary' />
          )
        }
      />
      <InstallationGuide />
    </PageWrapper>
  );
}
